var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("FormSubmitPopup", {
    attrs: {
      title: _vm.title,
      rightMethod: _vm.onSubmitted,
      rightButtonText: _vm.actionText,
      large: ""
    },
    on: {
      popupClose: function($event) {
        return _vm.$emit("input", false)
      }
    },
    scopedSlots: _vm._u([
      {
        key: "input",
        fn: function() {
          return [
            _c(
              "v-layout",
              { attrs: { wrap: "", "justify-start": "", "align-center": "" } },
              [
                _c(
                  "v-flex",
                  { attrs: { sm2: "", "ml-1": "", "mr-1": "" } },
                  [
                    _c(
                      "v-menu",
                      {
                        attrs: {
                          "close-on-content-click": false,
                          "nudge-right": 40,
                          lazy: "",
                          transition: "scale-transition",
                          "offset-y": "",
                          "full-width": "",
                          "min-width": "290px",
                          disabled: _vm.loading
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "activator",
                            fn: function(data) {
                              return [
                                _c(
                                  "v-text-field",
                                  _vm._g(
                                    {
                                      attrs: {
                                        label: _vm.$t("endDate"),
                                        "prepend-icon": "event",
                                        readonly: "",
                                        rules: [
                                          _vm.fieldIsRequired(
                                            "Announcement end date"
                                          ),
                                          function(value) {
                                            return (
                                              new Date(value) >
                                                _vm.endDateMinimum ||
                                              _vm.$t(
                                                "endDateMustLargeThanToday"
                                              )
                                            )
                                          }
                                        ]
                                      },
                                      model: {
                                        value: _vm.endDateFormatted,
                                        callback: function($$v) {
                                          _vm.endDateFormatted = $$v
                                        },
                                        expression: "endDateFormatted"
                                      }
                                    },
                                    data.on
                                  )
                                )
                              ]
                            }
                          }
                        ]),
                        model: {
                          value: _vm.endDatePicker,
                          callback: function($$v) {
                            _vm.endDatePicker = $$v
                          },
                          expression: "endDatePicker"
                        }
                      },
                      [
                        _vm._v(" "),
                        _c("v-date-picker", {
                          attrs: { min: _vm.endDateMinimum.toISOString() },
                          on: {
                            input: function($event) {
                              _vm.endDatePicker = false
                            }
                          },
                          model: {
                            value: _vm.newAnnouncement.endDate,
                            callback: function($$v) {
                              _vm.$set(_vm.newAnnouncement, "endDate", $$v)
                            },
                            expression: "newAnnouncement.endDate"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.isAdmin
                  ? _c(
                      "v-flex",
                      { attrs: { sm3: "", "ml-1": "", "mr-1": "" } },
                      [
                        _c("v-combobox", {
                          attrs: {
                            items: _vm.msgTypes,
                            "item-text": "displayName",
                            "item-value": "value",
                            label: _vm.$t("receivers"),
                            "return-object": false,
                            chips: "",
                            multiple: "",
                            clearable: ""
                          },
                          model: {
                            value: _vm.selectedMsgType,
                            callback: function($$v) {
                              _vm.selectedMsgType = $$v
                            },
                            expression: "selectedMsgType"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.isAdmin || _vm.isWarehouse
                  ? _c(
                      "v-flex",
                      { attrs: { sm3: "", "ml-1": "", "mr-1": "" } },
                      [
                        _c("v-combobox", {
                          attrs: {
                            items: _vm.allPaths,
                            label: _vm.$t("announcePath"),
                            chips: "",
                            multiple: "",
                            clearable: ""
                          },
                          model: {
                            value: _vm.selectedPaths,
                            callback: function($$v) {
                              _vm.selectedPaths = $$v
                            },
                            expression: "selectedPaths"
                          }
                        })
                      ],
                      1
                    )
                  : _vm.isOrganization
                  ? _c(
                      "v-flex",
                      { attrs: { sm2: "", "ml-1": "", "mr-1": "" } },
                      [
                        _c("v-checkbox", {
                          attrs: { label: _vm.$t("sendEmail") },
                          model: {
                            value: _vm.isSendOrganizationAnnouncementEmail,
                            callback: function($$v) {
                              _vm.isSendOrganizationAnnouncementEmail = $$v
                            },
                            expression: "isSendOrganizationAnnouncementEmail"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "v-flex",
                  { attrs: { sm2: "", "ml-4": "" } },
                  [
                    _c("v-checkbox", {
                      attrs: { label: _vm.$t("important") },
                      model: {
                        value: _vm.isImportant,
                        callback: function($$v) {
                          _vm.isImportant = $$v
                        },
                        expression: "isImportant"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _vm.isWarehouse
              ? _c(
                  "v-layout",
                  {
                    attrs: { wrap: "", "justify-start": "", "align-center": "" }
                  },
                  [
                    _c(
                      "v-flex",
                      { attrs: { sm3: "", "ml-1": "", "mr-1": "" } },
                      [
                        _c("v-combobox", {
                          attrs: {
                            items: _vm.userGroups,
                            "item-text": "orgType",
                            "item-value": "orgType",
                            label: _vm.$t("userGroups"),
                            chips: "",
                            multiple: "",
                            clearable: ""
                          },
                          on: {
                            change: function($event) {
                              return _vm.changeUserGroup(
                                $event,
                                _vm.selectedUserGroups
                              )
                            }
                          },
                          model: {
                            value: _vm.selectedUserGroups,
                            callback: function($$v) {
                              _vm.selectedUserGroups = $$v
                            },
                            expression: "selectedUserGroups"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-flex",
                      { attrs: { sm3: "", "ml-1": "", "mr-1": "" } },
                      [
                        _c("v-combobox", {
                          attrs: {
                            items: _vm.organizations,
                            "item-text": "organizationId",
                            "item-value": "organizationKey",
                            label: _vm.$t("organizations"),
                            chips: "",
                            multiple: "",
                            clearable: ""
                          },
                          model: {
                            value: _vm.selectedOrganizations,
                            callback: function($$v) {
                              _vm.selectedOrganizations = $$v
                            },
                            expression: "selectedOrganizations"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isWarehouse
              ? _c(
                  "v-layout",
                  {
                    attrs: { wrap: "", "justify-start": "", "align-center": "" }
                  },
                  [
                    _c(
                      "v-flex",
                      { attrs: { sm10: "" } },
                      [
                        _c("b", [
                          _vm._v(_vm._s(_vm.$t("uploadedFiles")) + ": ")
                        ]),
                        _vm._v(" "),
                        _c(
                          "v-layout",
                          { attrs: { row: "", wrap: "" } },
                          _vm._l(_vm.attachments || [], function(file, index) {
                            return _c("FsFileChip", {
                              key: "file" + index,
                              staticClass: "ma-2",
                              attrs: {
                                file: file,
                                width: "100%",
                                "aspect-ratio": "1.7"
                              }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-flex",
                      { attrs: { sm2: "" } },
                      [
                        _c("UploadFileWidget", {
                          ref: "fileUploader",
                          attrs: {
                            clearFiles: true,
                            type: "comments",
                            maxFiles: 9,
                            removeFiles: _vm.removeFiles,
                            icon: "",
                            isUseCameraUpload: ""
                          },
                          model: {
                            value: _vm.attachments,
                            callback: function($$v) {
                              _vm.attachments = $$v
                            },
                            expression: "attachments"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "v-layout",
              { attrs: { "pt-3": "", "justify-center": "", wrap: "" } },
              [
                _c("v-textarea", {
                  staticClass: "thinBox",
                  attrs: {
                    id: "msgContent",
                    label: _vm.$t("announcement"),
                    outline: "",
                    rows: "20",
                    rules: [_vm.fieldIsRequired("Announcement content")]
                  },
                  model: {
                    value: _vm.newAnnouncement.msgContent,
                    callback: function($$v) {
                      _vm.$set(_vm.newAnnouncement, "msgContent", $$v)
                    },
                    expression: "newAnnouncement.msgContent"
                  }
                })
              ],
              1
            )
          ]
        },
        proxy: true
      }
    ]),
    model: {
      value: _vm.value,
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2bc2dba1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2bc2dba1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AnnouncementEdit.vue
// module id = null
// module chunks = 